var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0456 13.535C14.2099 13.535 15.6033 12.3343 15.6033 10.1848C15.6033 8.42084 14.6694 6.79026 12.0456 6.79026H9.86657C9.36257 6.79026 8.93269 7.20531 8.93269 7.67967V16.5886C8.93269 17.0185 9.3181 17.3891 9.74799 17.3891C10.1927 17.3891 10.5633 17.0037 10.5633 16.5886V13.535H12.0456ZM10.5633 8.31708H12.0456C13.6169 8.31708 13.9727 9.25096 13.9727 10.17C13.9727 11.43 13.3056 12.023 12.0456 12.023H10.5633V8.31708Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 1.11765,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.84647d760ff1c684453d662aae7f06a9.svg";
export { ForwardRef as ReactComponent };